import { render } from "./BaseButton.vue?vue&type=template&id=3a066471&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=3a066471&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a066471"

export default script